import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import VoucherAd from '../components/voucher-ad'
import PackageTabs from '../components/package-tabs'
import config from '../../data/siteConfig'

const PackagesPage = () => (
  <span>
    <Helmet
      title={`${config.siteName} | Packages | ${config.siteTitleAlt}`}
      meta={[
        {
          name: 'description',
          content: 'Book your 4x4 experience day for corporate events with your work colleagues, Stag & Hen Parties or even "Stens", birthday parties or tailor-made events. Based in Cardiff South Wales with specially designed 4x4 off roading courses.'
        }
      ]}
    />
    <div className="packages banner">
      <div className="banner-info top-off-center text-center">
        <h2 className="uppercase">A true 4x4 Driving day with the Experts.</h2>
        <span className="spacer white hide-for-small-only">―</span>
        <h5 className="hide-for-small-only">Packages from £100 per person</h5>
        <a className="button secondary uppercase large hide-for-small-only" href="/bookings">Bookings</a>
      </div>
    </div>
    <main>
      <section className="row">
        <div className="small-12 medium-10 columns">
          <div className="content-header">
            <h1 className="uppercase">Packages</h1>
          </div>
        </div>
      </section>
      <section className="row">
        <div className="large-9 columns">
          <div className="content-body">
            <PackageTabs />
          </div>
        </div>
        <aside className="large-3 columns">
          <div className="content-body">
            <VoucherAd />
          </div>
        </aside>
      </section>
    </main>
  </span>
)

export default PackagesPage



// WEBPACK FOOTER //
// ./src/pages/packages.js